module.exports = __webpack_public_path__ + "static/media/Lion.defbaa0e.svg";